/**
 * Maximum email address length supported by CRM (inclusive).
 * Validate the full value; input maxLength can silently truncate it into a different valid address.
 */
export const EMAIL_MAX_LENGTH = 50;
